import {previewRequestInterval,requestRatePayload} from '../lib/providerRates.js';
import {BulkCapacity} from '../components/BulkCapacity';
import {FormEvent,useEffect,useState} from 'react';
import {api,ProcessingSettings,Provider,ProxyProfile,ProxyTest} from '../lib/api';

export function Settings(){
  const [providers,setProviders]=useState<Provider[]>([]);
  const [proxies,setProxies]=useState<ProxyProfile[]>([]);
  const [cfg,setCfg]=useState<ProcessingSettings>();
  const [error,setError]=useState('');
  const [saved,setSaved]=useState(false);
  const [formOpen,setFormOpen]=useState(false);
  const [editing,setEditing]=useState<Provider>();
  const [rps,setRps]=useState('');
  const [rpm,setRpm]=useState('');
  let ratePreview='';
  try{ratePreview=!editing&&rps.trim()===''&&rpm.trim()===''?'پیش‌فرض سرور (معمولاً ۲٫۲ ثانیه)':previewRequestInterval(rps,rpm,editing?.translation_fallback_interval_seconds??2.2).toFixed(3)+' ثانیه'}
  catch{ratePreview='مقدار واردشده معتبر نیست'}
  const [proxyFormOpen,setProxyFormOpen]=useState(false);
  const [editingProxy,setEditingProxy]=useState<ProxyProfile>();
  const [proxyTests,setProxyTests]=useState<Record<number,ProxyTest&{testing?:boolean}>>({});

  const load=()=>api.providers().then(setProviders).catch(x=>setError(x.message));
  const loadProxies=()=>api.proxies().then(setProxies).catch(x=>setError(x.message));
  useEffect(()=>{load();loadProxies();api.processingSettings().then(setCfg).catch(x=>setError(x.message))},[]);

  function openCreate(){setEditing(undefined);setRps('');setRpm('');setFormOpen(true);setError('')}
  function openEdit(p:Provider){setEditing(p);setRps(String(p.translation_requests_per_second??''));setRpm(String(p.translation_requests_per_minute??''));setFormOpen(true);setError('')}
  function closeForm(){setEditing(undefined);setFormOpen(false)}

  async function saveProvider(event:FormEvent<HTMLFormElement>){
    event.preventDefault();
    const form=new FormData(event.currentTarget);
    const key=String(form.get('key')||'');
    let rates;
    try{rates=requestRatePayload(rps,rpm)}catch(err){setError((err as Error).message);return}
    const payload={
      ...rates,
      name:String(form.get('name')),
      endpoint:String(form.get('endpoint')),
      api_type:'openai-compatible',
      transcription_model:String(form.get('stt')||'')||null,
      translation_model:String(form.get('translation')||'')||null,
      input_price_per_million:Number(form.get('input_price')||0)||null,
      output_price_per_million:Number(form.get('output_price')||0)||null,
      use_proxy:form.get('use_proxy')==='on',
      active:form.get('active')==='on',
      ...(key?{api_key:key}:{})
    };
    try{
      if(editing) await api.updateProvider(editing.id,payload);
      else await api.createProvider({...payload,api_key:key});
      closeForm();await load();
    }catch(err){setError((err as Error).message)}
  }

  function openProxyCreate(){setEditingProxy(undefined);setProxyFormOpen(true);setError('')}
  function openProxyEdit(p:ProxyProfile){setEditingProxy(p);setProxyFormOpen(true);setError('')}
  function closeProxyForm(){setEditingProxy(undefined);setProxyFormOpen(false)}
  async function saveProxy(event:FormEvent<HTMLFormElement>){
    event.preventDefault();
    const form=new FormData(event.currentTarget);
    const url=String(form.get('url')||'').trim();
    const payload={
      name:String(form.get('name')),
      priority:Number(form.get('priority')||100),
      active:form.get('active')==='on',
      ...(url?{url}:{})
    };
    try{
      if(editingProxy) await api.updateProxy(editingProxy.id,payload);
      else await api.createProxy(payload);
      closeProxyForm();await loadProxies();
    }catch(err){setError((err as Error).message)}
  }
  async function testProxy(p:ProxyProfile){
    setProxyTests(x=>({...x,[p.id]:{ok:false,testing:true}}));
    try{const result=await api.testProxy(p.id);setProxyTests(x=>({...x,[p.id]:result}))}
    catch(err){setProxyTests(x=>({...x,[p.id]:{ok:false,error:(err as Error).message}}))}
  }
  async function moveProxy(p:ProxyProfile,direction:'up'|'down'){
    try{setProxies(await api.moveProxy(p.id,direction))}
    catch(err){setError((err as Error).message)}
  }

  async function savePrompts(event:FormEvent){
    event.preventDefault();if(!cfg)return;
    try{setCfg(await api.saveProcessingSettings(cfg));setSaved(true);setTimeout(()=>setSaved(false),2000)}
    catch(err){setError((err as Error).message)}
  }

  return <div className="settingsStack">
    <BulkCapacity/>
    <section className="card settings">
      <div className="titleRow"><div><p className="eyebrow">SECURE CONFIGURATION</p><h2>AI Providerها</h2><p className="muted">کلیدها رمزنگاری می‌شوند و به مرورگر بازگردانده نمی‌شوند.</p></div><button className="primary" onClick={openCreate}>+ Provider جدید</button></div>
      {error&&<div className="error">{error}</div>}
      {formOpen&&<form className="providerForm" onSubmit={saveProvider}>
        <label>نام<input required name="name" defaultValue={editing?.name||''} placeholder="Groq / MixRoute"/></label>
        <label>Endpoint<input required dir="ltr" name="endpoint" defaultValue={editing?.endpoint||''} placeholder="https://api.example.com/v1"/></label>
        <label>API Key<input required={!editing} dir="ltr" type="password" name="key" placeholder={editing?'برای حفظ کلید فعلی خالی بگذارید':'API key'}/></label>
        <label>مدل transcription<input dir="ltr" name="stt" defaultValue={editing?.transcription_model||''} placeholder="whisper-large-v3-turbo"/></label>
        <label>مدل translation<input dir="ltr" name="translation" defaultValue={editing?.translation_model||''} placeholder="deepseek-v4-flash"/></label>
        <label>قیمت ورودی / 1M<input dir="ltr" type="number" step="0.000001" min="0" name="input_price" defaultValue={editing?.input_price_per_million||''}/></label>
        <label>قیمت خروجی / 1M<input dir="ltr" type="number" step="0.000001" min="0" name="output_price" defaultValue={editing?.output_price_per_million||''}/></label>
        <label>درخواست ترجمه در ثانیه (RPS)<input dir="ltr" type="number" min="0.01" max="10000" step="any" value={rps} onChange={e=>setRps(e.target.value)} placeholder="مثلاً 0.50"/></label>
        <label>درخواست ترجمه در دقیقه (RPM)<input dir="ltr" type="number" min="1" max="600000" step="any" value={rpm} onChange={e=>setRpm(e.target.value)} placeholder="مثلاً 60"/></label>
        <p className="wide muted">فاصلهٔ مؤثر: {ratePreview}. اگر هر دو مقدار وارد شوند، محدودیت سخت‌گیرانه‌تر با ۰٫۲ ثانیه حاشیه اعمال می‌شود. خالی: تنظیم قدیمی در صورت وجود، وگرنه پیش‌فرض ۲٫۲ ثانیه. فقط برای ترجمه؛ کنترل توکن در دقیقه نیست. کلیدهای یک حساب ممکن است محدودیت مشترک داشته باشند.</p>
        <label className="check"><input type="checkbox" name="use_proxy" defaultChecked={editing?.use_proxy??false}/> استفاده از زنجیره Proxy</label>
        <label className="check"><input type="checkbox" name="active" defaultChecked={editing?.active??true}/> فعال</label>
        <div className="formActions"><button type="button" className="secondary" onClick={closeForm}>انصراف</button><button className="primary">{editing?'ذخیره تغییرات':'ذخیره امن'}</button></div>
      </form>}
      <div className="providers">{providers.map(p=><article key={p.id}>
        <div className="providerIcon">AI</div><div><b>{p.name}</b><small dir="ltr">{p.endpoint}</small><small>{p.transcription_model||'—'} / {p.translation_model||'—'}</small>{p.translation_model&&<small>فاصلهٔ درخواست ترجمه: {p.translation_interval_seconds.toFixed(3)} ثانیه · {p.translation_interval_source==='provider_limits'?'محدودیت پنل':'تنظیم پیش‌فرض/قدیمی'}</small>}{p.use_proxy&&<small className="proxyUsed">Proxy فعال است</small>}</div>
        <div className="providerMeta"><i className={'badge '+(p.active?'completed':'')}>{p.active?'فعال':'غیرفعال'}</i><code>{p.api_key_masked}</code><button className="editButton" onClick={()=>openEdit(p)}>ویرایش</button><button aria-label="حذف" onClick={()=>confirm('Provider حذف شود؟')&&api.deleteProvider(p.id).then(load)}>×</button></div>
      </article>)}{!providers.length&&!formOpen&&<div className="empty">برای شروع، اولین Provider سازگار با OpenAI را اضافه کنید.</div>}</div>
    </section>
    <section className="card settings proxySettings">
      <div className="titleRow"><div><p className="eyebrow">PROXY FAILOVER</p><h2>Proxyها</h2><p className="muted">برای Providerهای دارای تیک Proxy، اتصال‌ها به ترتیب این فهرست امتحان می‌شوند. آدرس کامل رمزنگاری می‌شود.</p></div><button className="primary" onClick={openProxyCreate}>+ Proxy جدید</button></div>
      {proxyFormOpen&&<form className="providerForm" onSubmit={saveProxy}>
        <label>نام<input required name="name" defaultValue={editingProxy?.name||''} placeholder="VLESS Germany 1"/></label>
        <label>اولویت<input required dir="ltr" type="number" min="0" name="priority" defaultValue={editingProxy?.priority||100}/></label>
        <label className="wide">آدرس Proxy<input required={!editingProxy} dir="ltr" type="password" name="url" placeholder={editingProxy?'برای حفظ آدرس فعلی خالی بگذارید':'vless://... یا socks5://... یا http://...'}/></label>
        <label className="check"><input type="checkbox" name="active" defaultChecked={editingProxy?.active??true}/> فعال</label>
        <div className="formActions"><button type="button" className="secondary" onClick={closeProxyForm}>انصراف</button><button className="primary">{editingProxy?'ذخیره تغییرات':'ذخیره امن'}</button></div>
      </form>}
      <div className="proxyList">{proxies.map((p,index)=>{
        const test=proxyTests[p.id];
        return <article key={p.id}>
          <div className="proxyOrder"><button disabled={index===0} onClick={()=>moveProxy(p,'up')}>↑</button><b>{index+1}</b><button disabled={index===proxies.length-1} onClick={()=>moveProxy(p,'down')}>↓</button></div>
          <div className="proxyInfo"><b>{p.name}</b><small dir="ltr">{p.url_masked}</small><small>{p.proxy_type.toUpperCase()} · اولویت {p.priority}</small></div>
          <div className="providerMeta">
            <i className={'badge '+(p.active?'completed':'')}>{p.active?'فعال':'غیرفعال'}</i>
            {test&&<span className={'testResult '+(test.ok?'ok':'bad')}>{test.testing?'در حال تست…':test.ok?`${test.latency_ms}ms · ${test.outbound_ip}`:test.error}</span>}
            <button className="testButton" disabled={test?.testing} onClick={()=>testProxy(p)}>تست</button>
            <button className="editButton" onClick={()=>openProxyEdit(p)}>ویرایش</button>
            <button aria-label="حذف" onClick={()=>confirm('Proxy حذف شود؟')&&api.deleteProxy(p.id).then(loadProxies)}>×</button>
          </div>
        </article>
      })}{!proxies.length&&!proxyFormOpen&&<div className="empty">هنوز Proxy تعریف نشده است. VLESS، SOCKS5 و HTTP پشتیبانی می‌شوند.</div>}</div>
    </section>
    {cfg&&<form className="card promptSettings" onSubmit={savePrompts}><div><p className="eyebrow">PROCESSING DEFAULTS</p><h2>Promptهای پیش‌فرض</h2><p className="muted">در لحظه ساخت Job ذخیره می‌شوند تا تغییرات آینده روی Jobهای قبلی اثر نگذارد.</p></div><label>Transcription prompt<textarea dir="ltr" value={cfg.transcription_prompt} onChange={e=>setCfg({...cfg,transcription_prompt:e.target.value})}/></label><label>Translation prompt<textarea dir="ltr" value={cfg.translation_prompt} onChange={e=>setCfg({...cfg,translation_prompt:e.target.value})}/></label><button className="primary">{saved?'ذخیره شد ✓':'ذخیره Promptها'}</button></form>}
  </div>
}
